
import React, { useEffect, useState } from 'react';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import RegularButton from 'components/CustomButtons/Button';
import GridContainer from 'components/Grid/GridContainer';
import ReactTable from 'components/ReactTable/ReactTable';
import { Visibility } from '@material-ui/icons';
import GridItem from 'components/Grid/GridItem';
import { TextField } from '@material-ui/core';
import { wsFindBy } from 'services/WService';
import moment from 'moment';
import PriceRetentionModal from './PriceRetentionModal';
import { useModal } from 'hooks/useModal';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 125 },
  { Header: 'Fecha creación', accessor: 'created_at', width: 175 },
  { Header: 'Lista de precios', accessor: 'price_list', width: 200 },
  { Header: 'Creado por', accessor: 'createdBy' },
  { Header: 'Generado en ', accessor: 'generated_from' },
  { Header: 'Precios retenidos', accessor: 'prices_count' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

function PriceRetentionList() {
  const [retentions, setRetentions] = useState([]);
  const [startDate, setStartDate] = useState(moment().subtract(7, 'days').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));
  const [retentionModel, setRetentionModel] = useModal();
  const [dataLoading, setDataLoading] = useState(false);

  async function listRetentions() {
    setDataLoading(true);
    setRetentions([]);
    let res = await wsFindBy('logi/price-retention', {
      start_date: startDate,
      end_date: endDate,
      state: 'X',
    });
    setDataLoading(false);
    if (res.success) setRetentions(res.data);
  }

  useEffect(() => {
    listRetentions();
  }, [startDate, endDate]);

  return (
    <CardContainer /*title="Precios retenidos"*/ title={(<>Precio retendios {dataLoading && <LoadingSpinner />}</>)}>
      <PriceRetentionModal model={retentionModel} setOpen={setRetentionModel} reload={listRetentions} />
      <GridContainer>
        <GridItem xs={12} sm={6} md={4} lg={3} xl={2}>
          <TextField
            label="Desde"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            type="date"
            fullWidth
          />
        </GridItem>
        <GridItem xs={12} sm={6} md={4} lg={3} xl={2}>
          <TextField
            label="Hasta"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            type="date"
            fullWidth
          />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12}>
          <ReactTable
            columns={columns}
            data={retentions.map((retention, index) => {
              return {
                num: (
                  <>
                    {index + 1}
                    <RegularButton
                      justIcon
                      round
                      simple
                      color="primary"
                      onClick={() => setRetentionModel(retention)}
                    >
                      <Visibility />
                    </RegularButton>
                  </>
                ),
                created_at: retention.created_at,
                price_list: retention.price_list?.ListName || '-',
                generated_from: retention.generated_from,
                createdBy: retention.created_by.name,
                prices_count: retention.details_count,
              };
            })}
          />
        </GridItem>
      </GridContainer>
    </CardContainer>
  );
}

export default PriceRetentionList;
